<template>
  <div>
    <h2 class="mb-4">จัดการหมวดหมู่บทความ</h2>
    <CRow class="mb-3">
      <CCol md="5">
        <CButton color="success" @click="$refs.addModal.show()">
          <i class="fas fa-plus-circle"></i> เพิ่มหมวดหมู่
        </CButton>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="3">
        <CInput
          v-model="word"
          placeholder="ค้นหา"
          @keyup.enter="handleSearch"
        />
      </CCol>
      <CCol md="9">
        <div class="flex space-between mb-3">
          <CButton color="primary" @click="handleSearch"
            ><i class="fas fa-search"></i> ค้นหา
          </CButton>
          <CButton color="info" @click="handleDownload" :disabled="downloading">
            <i
              :class="
                downloading ? 'fas fa-spinner fa-spin' : 'far fa-file-excel'
              "
            ></i>
            {{ downloading ? 'Downloading...' : 'Excel download' }}
          </CButton>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-good-table
          mode="remote"
          :isLoading.sync="loading"
          :columns="columns"
          :rows="rows"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' }
          }"
          @on-sort-change="onSortChange"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'image'">
              <CImg
                :src="props.row.image"
                width="67"
                height="67"
                class="mx-auto"
                placeholderColor="lightgray"
                block
              />
            </span>
            <span v-else-if="props.column.field === 'bookImage'">
              <CImg
                :src="props.row.bookImage"
                width="67"
                height="67"
                class="mx-auto"
                placeholderColor="lightgray"
                block
              />
            </span>
            <span v-else-if="props.column.field == 'action'">
              <CButton
                color="warning"
                size="sm"
                class="m-1"
                @click="$refs.editModal.show(props.row)"
              >
                <i class="fa fa-pen"></i>
                <span class="sr-only">แก้ไขหมวดหมู่บทความ</span>
              </CButton>
              <CButton
                color="danger"
                variant="outline"
                size="sm"
                class="m-1"
                @click="$refs.deleteModal.show(props.row.id, props.row.name)"
              >
                <i class="fa fa-trash"></i>
                <span class="sr-only">ลบหมวดหมู่บทความ</span>
              </CButton>
            </span>
            <span v-else class="h6">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-ads-pagination
          :total-items="total"
          :max-visible-pages="5"
          :items-per-page="10"
          :page="search.page"
          :loading="loading"
        >
          <template slot-scope="props">
            <div class="vue-ads-pr-2 vue-ads-leading-loose">
              รายการที่ {{ props.start | decimalFormat }} ถึง
              {{ props.end | decimalFormat }} จาก
              {{ props.total | decimalFormat }} รายการ
            </div>
          </template>
          <template slot="buttons" slot-scope="props">
            <vue-ads-page-button
              v-for="(button, key) in props.buttons"
              :key="key"
              v-bind="button"
              @page-change="pageChange(button.page)"
            />
          </template>
        </vue-ads-pagination>
      </CCol>
    </CRow>

    <ArticleCategoryAddModal ref="addModal" :onComplete="getList" />
    <ArticleCategoryEditModal ref="editModal" :onComplete="getList" />
    <DeleteModal ref="deleteModal" :onConfirm="deleteCategory" />
  </div>
</template>

<script>
import moment from 'moment'

import ArticleCategoryAddModal from '../modal/ArticleCategoryAddModal'
import ArticleCategoryEditModal from '../modal/ArticleCategoryEditModal'
import DeleteModal from '../modal/DeleteModal'

import apiArticleCategory from '@/apis/article_category'

export default {
  name: 'Rfb3',
  components: {
    ArticleCategoryAddModal,
    ArticleCategoryEditModal,
    DeleteModal
  },
  data() {
    return {
      loading: false,
      downloading: false,
      word: '',
      search: {},
      defaultSearch: {
        page: 0,
        limit: 10,
        sort: {
          field: 'nameTH',
          type: 'asc'
        }
      },
      total: 0,
      filterSelected: 'nameTH',
      filter: [{ value: 'nameTH', label: 'ชื่อหมวดหมู่' }],
      columns: [
        {
          label: 'ลำดับ',
          field: 'no',
          width: '50px',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false
        },
        {
          label: 'ชื่อหมวดหมู่',
          field: 'name',
          thClass: 'min-width-250 align-middle',
          tdClass: 'min-width-250'
        },
        {
          label: 'ภาพประกอบหมวดหมู่',
          field: 'image',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'align-middle',
          width: '160px'
        },
        {
          label: 'ภาพปกบทความ',
          field: 'bookImage',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'align-middle',
          width: '160px'
        },
        {
          field: 'action',
          sortable: false,
          tdClass: 'text-center align-middle'
        }
      ],
      rows: []
    }
  },
  created() {
    this.search = Object.assign({}, this.defaultSearch)
  },
  methods: {
    handleSearch() {
      this.search = Object.assign({}, this.defaultSearch)
      if (this.word) this.search[this.filterSelected] = this.word

      this.getList()
    },
    handleDownload() {
      this.downloading = true
      apiArticleCategory
        .download()
        .then((data) => {
          const blob = new Blob([data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)

          link.target = '_blank'
          link.download = `${moment().format(
            'YYYYMMDDHHmm'
          )}_article_categories.csv`
          link.click()
          URL.revokeObjectURL(link.href)

          this.downloading = false
        })
        .catch(() => {
          this.downloading = false
        })
    },
    pageChange(page) {
      this.search.page = page
      this.getList()
    },
    onSortChange(params) {
      this.search.sort = params[0]
      this.getList()
    },
    getList() {
      this.loading = true

      apiArticleCategory
        .getList(this.search)
        .then((result) => {
          this.total = result.data.totalDocs
          this.rows = []
          for (let i = 0; i < result.data.docs.length; i++) {
            const item = result.data.docs[i]
            this.rows.push({
              no: this.search.page * this.search.limit + i + 1,
              id: item._id,
              image: item.imageUrl,
              bookImage: item.bookImageUrl,
              name: item.name,
              nameTH: item.nameTH,
              nameEN: item.nameEN,
              nameDZ: item.nameDZ
            })
          }
          this.loading = false
        })
        .catch(() => {
          this.rows = []
          this.loading = false
        })
    },
    deleteCategory(id) {
      this.loading = true
      apiArticleCategory
        .remove(id)
        .then(() => {
          this.getList()
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
